import { stringify } from 'qs';
import { useMultipleContentCollections } from './useContent';
import { Content, ContentType } from 'src/types/content';
export const CmsTagToContentType = {
  'report-help': 'api::report-help.report-help',
  'glossary-term': 'api::glossary-term.glossary-term',
  kpi: 'api::kpi.kpi'
} as Record<string, ContentType>;
type ReportHelpContentType = Content<ContentType> & {
  identifier: string;
};
export function useReportHelpContent(contentToFetch: Record<string, string[]>): {
  isLoading: boolean;
  content?: Record<string, Content<ContentType>>;
} {
  const queries = Object.entries(contentToFetch).reduce((acc, [cmsTag, identifiers]) => {
    const contentType = CmsTagToContentType[cmsTag];
    const query = `?${stringify({
      filters: {
        identifier: {
          $in: identifiers
        }
      }
    })}&populate=*`;
    if (contentType && identifiers.length > 0) {
      acc[contentType] = query;
    }
    return acc;
  }, {} as Record<ContentType, string>);
  const results = useMultipleContentCollections(queries);
  if (results.isLoading) {
    return {
      isLoading: true,
      content: undefined
    };
  }
  const contentMap: Record<string, Content<ContentType>> = {};
  let entryIndex = 0;
  Object.entries(contentToFetch).forEach(([cmsTag_0, identifiers_0]) => {
    const contentType_0 = CmsTagToContentType[cmsTag_0];
    if (contentType_0 && results.data[entryIndex]) {
      const responseData = results.data[entryIndex];
      identifiers_0.forEach(identifier => {
        const content = responseData?.data?.find(item => (item as ReportHelpContentType).identifier === identifier);
        if (content) {
          contentMap[`${cmsTag_0}:${identifier}`] = content;
        }
      });
      entryIndex++;
    }
  });
  return {
    isLoading: false,
    content: contentMap
  };
}